import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState, selectCurrencyInCommonState } from 'app/app-state.index';
import { CurrencyType, Language, PaymentType, SiteDocsUrl } from 'app/shared/model/enums';
import { Observable, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { WebRouletteSubscription } from '../model/web-roulette-subscription.model';

@Injectable({
  providedIn: 'root'
})
export class SubscriptionService {





  constructor(private httpClient: HttpClient) {
  }

  getSubscriptions(rouletteId: number, currency: CurrencyType,language: Language): Observable<WebRouletteSubscription[]> {
    return this.httpClient.post<{ Subscriptions: WebRouletteSubscription[] }>('/webroulette/subscriptions', { rouletteId, currency,language })
      .pipe(map((response) => {
        return response.Subscriptions
      }));
  }
  getAllSubscriptions(currency: CurrencyType, language: Language): Observable<WebRouletteSubscription[]> {
    return this.httpClient.post<{ Subscriptions: WebRouletteSubscription[] }>('/webroulette/allsubscriptions', { currency,language })
      .pipe(map((response) => {
        return response.Subscriptions
      }));
  }
  getMockPaymentStatus() {
    return this.httpClient.get(`/common/getMockPaymentStatus`);
  }

  buyTestSubscription(request: { rouletteId: number, packageId: number, productId: number,AutoRenwal:boolean,PaymentType:PaymentType}) {     
    return this.httpClient.post(`/webroulette/buyTestSubscription`, request);
  }
  buyFreeSubscription(rouletteId: number, packageId: number) {
    return this.httpClient.post(`/webroulette/buyFreeSubscription`, { rouletteId, packageId });

  }
  changeRenewalPackage(rouletteId: number, renewal: boolean) {
    return this.httpClient.post(`/webroulette/changeAutoRenewalRoulette`, { rouletteId, renewal });
  }
  cancelRouletteSubscription(rouletteId: number) {
    return this.httpClient.post(`/webroulette/cancelRouletteSubscription`, { rouletteId });
  }
  createStripeSessionForAutoRenewal(rouletteId: number, successPaymentLink: string, failedPaymentLink: string) {
    return this.httpClient.post(`/webroulette/createStripeSessionForAutoRenewal`, { rouletteId, successPaymentLink, failedPaymentLink });
  }
  getSiteDocUrl(docType: SiteDocsUrl): Observable<string> {
    return this.httpClient.get<string>(`/common/GetSiteDocsUrls?docType=${docType}`);
  }
}
